import { TicketMultilingualSettingsBuilder } from './../ticket-multilingual-settings/ticket-multilingual-settings.builder';
var TicketTenantSettingsBuilder = /** @class */ (function () {
    function TicketTenantSettingsBuilder() {
        this.ticketTenantSettings = {
            enabled: true,
            multilingualSettings: {
                en: new TicketMultilingualSettingsBuilder().build()
            },
            useCaptcha: false,
            publicEnabled: true,
            contactFormEnabled: true,
            kbEnabled: true,
            publicPageEnabled: true,
            guestContactFormEnabled: false,
            maxPendingTime: 10,
            spamFilter: []
        };
    }
    TicketTenantSettingsBuilder.prototype.withEnabled = function (enabled) {
        this.ticketTenantSettings.enabled = enabled;
        return this;
    };
    TicketTenantSettingsBuilder.prototype.withUseCaptcha = function (useCaptcha) {
        this.ticketTenantSettings.useCaptcha = useCaptcha;
        return this;
    };
    TicketTenantSettingsBuilder.prototype.withPublicEnabled = function (publicEnabled) {
        this.ticketTenantSettings.publicEnabled = publicEnabled;
        return this;
    };
    TicketTenantSettingsBuilder.prototype.withContactFormEnabled = function (contactFormEnabled) {
        this.ticketTenantSettings.contactFormEnabled = contactFormEnabled;
        return this;
    };
    TicketTenantSettingsBuilder.prototype.withKbEnabled = function (kbEnabled) {
        this.ticketTenantSettings.kbEnabled = kbEnabled;
        return this;
    };
    TicketTenantSettingsBuilder.prototype.withPublicPageEnabled = function (publicPageEnabled) {
        this.ticketTenantSettings.publicPageEnabled = publicPageEnabled;
        return this;
    };
    TicketTenantSettingsBuilder.prototype.withGuestContactFormEnabled = function (guestContactFormEnabled) {
        this.ticketTenantSettings.guestContactFormEnabled = guestContactFormEnabled;
        return this;
    };
    TicketTenantSettingsBuilder.prototype.withMaxPendingTime = function (maxPendingTime) {
        this.ticketTenantSettings.maxPendingTime = maxPendingTime;
        return this;
    };
    TicketTenantSettingsBuilder.prototype.withSpamFilter = function (spamFilter) {
        this.ticketTenantSettings.spamFilter = spamFilter;
        return this;
    };
    TicketTenantSettingsBuilder.prototype.withMultilingualSettings = function (multilingualSettings) {
        this.ticketTenantSettings.multilingualSettings = multilingualSettings;
        return this;
    };
    TicketTenantSettingsBuilder.prototype.build = function () {
        return this.ticketTenantSettings;
    };
    return TicketTenantSettingsBuilder;
}());
export { TicketTenantSettingsBuilder };
//# sourceMappingURL=ticket-tenant-settings.builder.js.map